import { Stack, Typography } from '@mui/material';
import { ResultBox } from './ResultBox';

export function ResultRow({ title, value, showBorder = true }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing="16px">
      <Typography variant="h6" color="textPrimary" component="h6">
        {title}
      </Typography>
      <ResultBox value={value} showBorder={showBorder} />
    </Stack>
  );
}
